export const isStateEqual = (objA, objB) => {
	return JSON.stringify(objA) === JSON.stringify(objB);
};
